import React, { ReactNode } from 'react';
import { AppLayoutProvider } from '@mds/app-layout';
import { theme as mdsTheme, themeVars } from '@mds/ui';
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import InitColorSchemeScript from '@mui/material/InitColorSchemeScript';
import { Theme, ThemeProvider } from '@mui/material/styles';
import { reactRouterV5Adapter } from './mdsReactRouterV5Adapter';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

const modeStorageKey = 'neon-insights-mds-mode';
const colorSchemeStorageKey = 'neon-insights-mds-color-scheme';

const muiLinkResetStyles = (theme: Theme) => {
    const linkDefault = themeVars(theme).palette.link.default;

    return {
        '.MuiLink-root': {
            fontFamily: 'inherit',
            fontSize: 'inherit',
        },
        '.MuiLink-root:hover, .MuiLink-root.MuiTypography-colorPrimary, .MuiLink-root.MuiTypography-colorPrimary:hover':
            {
                color: linkDefault,
            },
        '.MuiLink-root.MuiTypography-colorInherit:hover': {
            color: 'inherit',
        },
        '.MuiCheckbox-root, .MuiRadio-root': {
            padding: theme.spacing(0.5),
        },
        '.MuiCheckbox-root .MuiSvgIcon-root, .MuiRadio-root .MuiSvgIcon-root': {
            fontSize: 18,
        },
    };
};

interface MdsThemeProviderProps {
    children: ReactNode;
}

export const MdsThemeProvider: React.FC<MdsThemeProviderProps> = ({
    children,
}) => {
    return (
        <>
            <InitColorSchemeScript
                attribute="data-color-scheme"
                defaultMode="dark"
                modeStorageKey={modeStorageKey}
                colorSchemeStorageKey={colorSchemeStorageKey}
            />
            <ThemeProvider
                theme={mdsTheme}
                defaultMode="dark"
                modeStorageKey={modeStorageKey}
                colorSchemeStorageKey={colorSchemeStorageKey}
                disableTransitionOnChange
            >
                <CssBaseline enableColorScheme />
                <GlobalStyles styles={muiLinkResetStyles} />
                <AppLayoutProvider adapter={reactRouterV5Adapter}>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                        {children}
                    </LocalizationProvider>
                </AppLayoutProvider>
            </ThemeProvider>
        </>
    );
};
